module.exports = __webpack_public_path__ + "img/Group195.24ed013a.png";